import { AppThunk } from '../../../store/reducers';
import { GET, POST, PATCH, DELETE } from '../../../service/HttpMethod';
import { beforeSend } from '../../../components/Toast/Store';
import { InitialState, List, Details, ActionConstant, ActionType } from './types';
import { toastFunction } from '../../../helpers/toastShow';

const initialState: InitialState = {
	initialList: true,
	fetching: true,
	detailsFetching: true,
	list: [],
	total: 0,
	details: {
		id: 0,
		name: '',
		isDefault: false,
		hasAIPrompts: false,
		defaultPackageName: '',
		materialStatusInstructions: '',
		materialScheduleInstructions: '',
	},
	statusCode: 0,
	noOfResults: 0,
	totalResults: 0,
};

const GetListAction = (data: List): ActionType => ({
	type: ActionConstant.GET_LIST,
	data,
});

const GetDetailsAction = (data: Details): ActionType => ({
	type: ActionConstant.GET_DETAILS,
	data,
});

export const getList = (): AppThunk => {
	const getConfig = { url: `trade` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			data.data.rows.sort((a: any, b: any) =>
				a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }),
			);

			dispatch(GetListAction(data.data));
		} catch (error) {
			// dispatch(GetListAction([]));
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const getDetails = (id = 0): AppThunk => {
	const getConfig = { url: `trade/${id}` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetDetailsAction(data.data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export function create(datas = {}): AppThunk {
	const postConfig = {
		data: datas,
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		url: `trade`,
	};
	return async (dispatch) => {
		try {
			dispatch(beforeSend());
			const { status = 0 } = await POST(postConfig);
			dispatch(toastFunction('Success', 'Trade created successfully', ''));
			dispatch(getList());
			dispatch({ type: ActionConstant.GET_STATUS, status });
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
}

export function updateAction(datas = {}, id = 0): AppThunk {
	const postConfig = {
		data: datas,
		url: `trade/${id}`,
	};
	return async (dispatch) => {
		try {
			const { status = 0 } = await PATCH(postConfig);

			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(toastFunction('Success', 'Trade updated successfully', ''));
			dispatch(getDetails(id));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Trade updation failed', ''));
		}
	};
}

export function deleteAction(id = 0): AppThunk {
	const delConfig = { url: `trade/${id}` };
	return async function (dispatch) {
		try {
			const { status = 0 } = await DELETE(delConfig);
			dispatch(toastFunction('Success', 'Trade deleted successfully', ''));
			dispatch(getList());
			dispatch({ type: ActionConstant.GET_STATUS, status });
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Trade deletion failed', ''));
		}
	};
}

export const clearDetails = (): ActionType => ({ type: ActionConstant.CLEAR_DETAILS });
export const clearStatus = (): ActionType => ({ type: ActionConstant.CLEAR_STATUS });

function tradeReducer(state = initialState, action: ActionType): InitialState {
	switch (action.type) {
		case ActionConstant.GET_LIST: {
			state.list = [];
			const { count = 0, rows = [] } = action.data;
			return {
				...state,
				list: [...state.list, ...rows],
				total: count,
				fetching: false,
			};
		}
		case ActionConstant.GET_DETAILS: {
			const { data } = action;
			return {
				...state,
				details: data,
				detailsFetching: false,
			};
		}
		case ActionConstant.GET_STATUS: {
			return {
				...state,
				statusCode: action.status,
			};
		}
		case ActionConstant.CLEAR_DETAILS: {
			return {
				...state,
				details: {
					id: 0,
					name: '',
					isDefault: false,
					hasAIPrompts: false,
					defaultPackageName: '',
					materialStatusInstructions: '',
					materialScheduleInstructions: '',
				},
				detailsFetching: true,
			};
		}
		case ActionConstant.CLEAR_STATUS: {
			return {
				...state,
				statusCode: 0,
			};
		}

		default:
			return state;
	}
}

export default tradeReducer;
